import React from 'react';
import styled, { ITheme } from 'styled-components';
import ButtonOutline from '../ButtonOutline/Button.outline';
import TelegramIcon from '../Icons/icon.Telegram';
import TwitterIcon from '../Icons/icon.Twitter';

const Wrapper = styled.div`
    max-width: 1272px;
    width: 100%;
    margin: 0 auto;
    .notoken {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: ${({ theme }: { theme: ITheme }) => theme.text1};
        text-align: center;
        padding: 80px 160px;
        border: 0.5px solid ${({ theme }: { theme: ITheme }) => theme.border1};
        border-radius: 8px;
        .box-button {
            margin-top: 28px;
            display: flex;
            gap: 16px;
            justify-content: center;
        }
    }
    ${({ theme }: { theme: ITheme }) => theme.mediaWidth.upToMedium`
        padding: 50px 16px;
        .notoken {
            display: flex;
            flex-direction: column;
            padding: 40px 0;
            .box-button {
                flex-direction: column;
            }
        }
    `}
`;

const initContent = 'There is currently no Live token sales, follow our Twitter and Telegram for latest updates';

export default function NoTokenLive({ title = initContent, mtTop = 0 }: { title?: string; mtTop?: number }) {
    return (
        <Wrapper style={{ marginTop: mtTop }}>
            <div className="notoken">
                <div className="fs-supermedium fs-regular">{title}</div>
                <div className="box-button">
                    <ButtonOutline
                        title="Follow on Twitter"
                        onClick={() => {
                            window.open('https://twitter.com/InfiniteLaunch');
                        }}
                        icon={() => <TwitterIcon />}
                    />
                    <ButtonOutline
                        title="Follow on Telegram"
                        onClick={() => {
                            window.open('https://t.me/InfiniteLaunchNews');
                        }}
                        icon={() => <TelegramIcon />}
                    />
                </div>
            </div>
        </Wrapper>
    );
}
